import Joi from 'joi';

const vpPhoneNumberJoiExtension = (joi) => ({
  base: joi.string(),
  type: 'string',
  messages: {
    'vpPhoneNumber.letters': '"{{#label}}" should not contain any letters.',
  },
  rules: {
    vpPhoneNumber: {
      validate(value, { error }) {
        if (!value) return value;
        if (!value.match(/^[^a-zA-Z]+$/)) return error('vpPhoneNumber.letters');
        return value;
      },
    },
  },
});

const vpFullNameJoiExtension = (joi) => ({
  base: joi.string(),
  type: 'string',
  messages: {
    'vpFullName.digits': '"{{#label}}" should not contain digits.',
  },
  rules: {
    vpFullName: {
      validate(value, { error }) {
        if (!value) return value;
        if (!value.match(/^\D+$/)) return error('vpFullName.digits');
        return value;
      },
    },
  },
});

const JoiExtended = Joi.extend(
  require('joi-phone-number'),
  vpPhoneNumberJoiExtension,
  vpFullNameJoiExtension,
);

export default JoiExtended;
